import React, { useEffect } from 'react';
import { CheckCircle, XCircle, Info, AlertTriangle } from 'lucide-react';

const toastConfig = {
    success: { Icon: CheckCircle, barClass: 'bg-green-500' },
    error: { Icon: XCircle, barClass: 'bg-red-500' },
    info: { Icon: Info, barClass: 'bg-blue-500' },
    warning: { Icon: AlertTriangle, barClass: 'bg-yellow-500' },
};

const Toast = ({ message, type = 'info', onDismiss }) => {
    useEffect(() => {
        if (!message) return;
        const timer = setTimeout(() => {
            onDismiss();
        }, 5000);
        return () => clearTimeout(timer);
    }, [message, onDismiss]);

    if (!message) return null;

    const { Icon, barClass } = toastConfig[type] || toastConfig.info;

    return (
        <div className="fixed top-5 left-1/2 -translate-x-1/2 max-w-sm w-11/12 z-50 animate-fade-in-down">
            <div className="bg-white rounded-lg shadow-lg flex items-center overflow-hidden">
                <div className={`w-2 h-full self-stretch ${barClass}`}></div>
                <div className="p-4 flex items-center">
                    <Icon className={`w-6 h-6 mr-3 ${barClass.replace('bg', 'text')}`} />
                    <p className="text-sm text-gray-700">{message}</p>
                </div>
            </div>
        </div>
    );
};

export default Toast;
